import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConfigurationToolbar = ({ 
  currency, 
  onCurrencyChange, 
  vatEnabled, 
  onVatToggle,
  onExport,
  onImport 
}) => {
  const currencies = [
    { code: 'ZAR', symbol: 'R', name: 'South African Rand' },
    { code: 'USD', symbol: '$', name: 'US Dollar' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
        <div className="flex items-center gap-4 flex-wrap">
          <div className="flex items-center gap-2">
            <Icon name="Settings2" size={20} className="text-muted-foreground" />
            <span className="text-sm font-medium text-foreground">Configuration</span>
          </div>

          <div className="flex items-center gap-2">
            <label className="text-sm text-muted-foreground">Currency:</label>
            <div className="flex gap-1 bg-muted rounded-md p-1">
              {currencies?.map((curr) => (
                <button
                  key={curr?.code}
                  onClick={() => onCurrencyChange(curr?.code)}
                  className={`px-3 py-1.5 rounded text-sm font-medium transition-all duration-200 ${
                    currency === curr?.code
                      ? 'bg-primary text-primary-foreground shadow-sm'
                      : 'text-muted-foreground hover:text-foreground'
                  }`}
                >
                  {curr?.symbol} {curr?.code}
                </button>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <label className="text-sm text-muted-foreground">VAT (15%):</label>
            <button
              onClick={onVatToggle}
              className={`relative w-11 h-6 rounded-full transition-colors duration-200 ${
                vatEnabled ? 'bg-primary' : 'bg-input'
              }`}
            >
              <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform duration-200 ${
                vatEnabled ? 'translate-x-5' : 'translate-x-0'
              }`} />
            </button>
            <span className="text-sm font-medium text-foreground">
              {vatEnabled ? 'Inclusive' : 'Exclusive'}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onImport}
            iconName="Upload"
            iconPosition="left"
          >
            Import
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={onExport}
            iconName="Download"
            iconPosition="left"
          >
            Export
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfigurationToolbar;